// extracted by mini-css-extract-plugin
module.exports = {"loadingPlaceholder":"loadingPlaceholder-F1nxB"};